export const flags = {
  UK: require('./uk.png'),
}
